import { EditConfigurationValidationWarningsModal } from 'components/Modals/EditConfigurationValidationWarningsModal/EditConfigurationValidationWarningsModal';
import {
  ByCodeflexText,
  ByCodeflexWrapper,
  Container,
  Row,
  Wrapper,
} from './OrderForm.styled';
import { ReactComponent as CodeflexLogo } from 'assets/icons/codeflexLogoTextRight.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import Icon from 'components/Icon/Icon';
import { COLORS } from 'assets/styled';
import FormImages from 'pages/ConfigurePage/FormImages/FormImages';
import ConfigureForm from 'pages/ConfigurePage/ConfigureForm/ConfigureForm';
import { useHasImages } from 'utils/hooks/useHasImages';
import {
  IImageSection,
  useFilterOutHiddenImages,
} from 'pages/ConfigurePage/FormImages/hooks';

const OrderForm = () => {
  const { t } = useTranslation();
  const images = useSelector(
    (state: IRootReducerState) => state.modelInfo.images
  );
  const visibleImages: IImageSection[] = useFilterOutHiddenImages(images);

  // Used for toggling between 2 form styles
  const hasImages = useHasImages(!!visibleImages.length);

  return (
    <>
      <Wrapper>
        <Container hasImages={hasImages}>
          <Row>
            <FormImages visibleImages={visibleImages} />
            <ConfigureForm hasImages={hasImages} />
          </Row>
          <ByCodeflexWrapper>
            <ByCodeflexText>{t('Powered by')}:</ByCodeflexText>
            <Icon svg={CodeflexLogo} size={123} fill={COLORS.BLACK} />
          </ByCodeflexWrapper>
          <EditConfigurationValidationWarningsModal />
        </Container>
      </Wrapper>
    </>
  );
};

export default OrderForm;
